var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showSearch && _vm.loaded)?_c('SearchComponent',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close),expression:"close"}]}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }